export default __webpack_public_path__ + "static/sa-etape2-b93ac03d06fbafafe898360bef3b8086.jpeg";